export const Modals = {
    showModals: {
        external: false,
        fieldFacilitatorForm: false,
        farmerForm: false,
        farmerTrashed: false,
        farmerDetail: false,
        place: false,
        landDetail: false,
    }
}